import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography,  Box, TextField, } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectAdminParticipantById } from '../../../reducers/admincenter_participants';
import { selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages';
import { fetchParticipantPasswords, participantpasswordClear } from '../../../reducers/admincenter_participantpassword';
import { selectParticipantDemographicsById } from '../../../reducers/admincenter_participantdemographics';


const ParticipantResetPassword = (props) => {
    const dispatch = useDispatch()

    const ParticipantGuid = props.Participant.ParticipantGuid
    const Participant = useSelector(state => selectAdminParticipantById(state, ParticipantGuid))
    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))
    const CombinedData = ({ ...Participant, ...ParticipantAdditionalInfo })
    const { user: currentUser } = useSelector((state) => state.auth);
    //console.log('participant', CombinedData)
    const [localEmailState, setLocalEmailState] = useState("")

    const participantPasswordStatus = useSelector(state => state.participantpasswords.status)
    const participantPasswordError = useSelector(state => state.participantpasswords.error)
    const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, participantPasswordError && participantPasswordError.ErrorID))
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        if (participantPasswordStatus === "success") {

            handleCancel()
        }
        else if (participantPasswordStatus === "failed") {
            setIsError(true)
        }
    }, [participantPasswordStatus])

    useEffect(() => {
        if (!localEmailState && CombinedData.Email) {
            setLocalEmailState(CombinedData.Email)
        }
    }, [CombinedData, dispatch])

    const handleCancel = () => {
        setIsError(false)
        dispatch(participantpasswordClear())
        props.cancelButton()
    }

    const handleResetPassword = () => {
        // + incomingVariable.authToken + "/" 
        // + incomingVariable.GroupGuid + "/"
        // + incomingVariable.UserName + "/"
        // + "1" + "/"
        // + incomingVariable.Email + "/"
        dispatch(fetchParticipantPasswords(
            {
                authToken: currentUser.AuthToken
                , GroupGuid: CombinedData.GroupGuid
                , UserName: CombinedData.UserName
                , Email: localEmailState
            }))
    }

    function ValidateEmail(input) {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (input.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    }
    const ValidTo = ValidateEmail(localEmailState)
    return (
        <Box>
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" align="center">EMAIL LINK TO PASSWORD RESET PAGE</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1" align="center">An email will be sent to the address below, with a link to the password reset page</Typography>
                </Grid>
                <Grid item xs={12} justifyContent="center" display="flex">
                    <TextField variant="standard" align="center" placeholder="Email" value={localEmailState} onChange={(e) => { setLocalEmailState(e.target.value) }} />
                </Grid>
                {/* <Grid item xs={12} justifyContent="center" display="flex">
                    <TextField variant="standard" align="center" placeholder="Password" value={props.Participant.Email}/>
                </Grid> */}

                <Grid item xs={12} justifyContent="center">
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                        <Grid item xs={3}>
                            <Box display="flex" justifyContent="center">
                                <Button fullWidth variant="contained" color="success"
                                    disabled={!ValidTo}
                                    onClick={() => { handleResetPassword() }}>Send</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box display="flex" justifyContent="center">
                                <Button fullWidth variant="contained" color="error" onClick={() => { handleCancel() }}>Cancel</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                {/* <Grid item xs={12} justifyContent="center" display="flex">
                    <Typography variant="caption">Manually gnerate a temporary password</Typography>
                </Grid> */}
                {

                    isError === true && (
                        <Grid item xs={12}>
                            <Box>
                                <Typography variant="h6" color="error" align="center">
                                    {
                                        (ErrorMessage && ErrorMessage.length > 0 && ErrorMessage[0].MessageTypeContent)
                                        ||
                                        (participantPasswordError && participantPasswordError.ErrorMessage)
                                    }
                                </Typography>
                            </Box>
                        </Grid>
                    )
                }
            </Grid>
        </Box>
    )
}

export default ParticipantResetPassword